// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"TeacherTraining_Wrapper__3yLem","Title":"TeacherTraining_Title__2mY4i","Date":"TeacherTraining_Date__1OxOM","Message":"TeacherTraining_Message__1cBgt"};